export default __webpack_public_path__ + "static/media/filter.7989431b.svg";